<template>
  <nav
    :class="$style['navigation-linear']"
  >
    <div
      :class="$style['navigation-linear__cta']"
    >
      <ButtonPrimaryFluid
        :state="buttonState"
        :type="onPress ? ButtonType.Button : ButtonType.Submit"
        @click="onClick"
      >
        <template
          #icon
        >
          <slot
            name="icon"
          />
        </template>
        <slot />
      </ButtonPrimaryFluid>
    </div>
    <Paragraph5>
      <slot
        v-if="$slots.ctaExplainer"
        name="ctaExplainer"
      />
    </Paragraph5>
  </nav>
</template>

<script lang="ts">
import { ActionState } from '../../actions/ActionState'
import ButtonPrimaryFluid from '../primary-fluid/ButtonPrimaryFluid.vue'
import { ButtonType } from '../ButtonType'
import { Paragraph5 } from '~/components-daisy/typography'

export default defineComponent({
  name: 'NavigationLinear',
  components: {
    Paragraph5,
    ButtonPrimaryFluid,
  },
  inheritAttrs: false,
  props: {
    onPress: {
      type: Function as PropType<(() => void) | undefined>,
      required: false,
      default: undefined,
    },
    buttonState: {
      type: String as PropType<ActionState>,
      required: false,
      default: ActionState.Idle,
    },
  },
  emit: ['click'],
  setup(props) {
    function onClick() {
      props.onPress?.()
    }

    return {
      onClick,
      ButtonType,
    }
  },
})
</script>

<style lang="postcss" module>
.navigation-linear {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-100);
  min-width: 100%;
  text-align: center;
  text-wrap: balance;

  &__cta {
    flex: 1;
    width: 100%;
    border-radius: var(--border-radius-800);
    max-width: 325px;
  }
}
</style>
